import { environment } from 'environments/environment';
import { DBConfig } from 'ngx-indexed-db';

export const dbConfig: DBConfig  = {
  name: environment.appName,
  version: environment.cacheVersion,
  objectStoresMeta: [{
    store: 'cache',
    storeConfig: { keyPath: 'key', autoIncrement: true },
    storeSchema: [
      { name: 'value', keypath: 'value', options: { unique: false } },
      { name: 'expire', keypath: 'expire', options: { unique: false } }
    ]
  }]
};
